export default function WhoWeAre() {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[420px] md:h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/11181f3b5f5abc4bb6d4b3e1dd6b6b8c.jpg"
                alt="omandisposables.com Warehouse - Wholesale Gloves Oman"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-5 -right-5 md:bottom-6 md:right-6 bg-navy text-white p-5 rounded-2xl shadow-xl">
              <p className="font-heading font-black text-5xl text-brand-green">500+</p>
              <p className="font-heading font-bold text-sm">Wholesale Clients</p>
              <p className="font-arabic text-white/80 text-xs mt-0.5" dir="rtl">عميل بالجملة</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="trust-badge mb-5 inline-flex">🇴🇲 Our Story</span>
            <h2 className="section-title-en text-3xl md:text-4xl mb-2">
              Who We Are — omandisposables.com
            </h2>
            <p className="section-title-ar text-2xl md:text-3xl mb-6" dir="rtl">
              من نحن — عُمان ديسبوزابلز
            </p>

            <div className="space-y-4 text-gray-600 text-sm md:text-base leading-relaxed">
              <p>
                Founded in Oman, omandisposables.com — the commercial platform of{' '}
                <span className="text-gray-600">Attiyaf Al Jazeera Household Utensils LLC</span>{' '}
                — has grown into one of the most trusted wholesale disposable gloves suppliers across the GCC.
                We&apos;ve served hospitals, food processing plants, laboratories, and industrial facilities
                with consistent quality and reliable supply.
              </p>
              <p>
                Our deep roots in Oman mean we understand the regional market — its regulations,
                supply chain demands, and the high standards required by GCC buyers. From Muscat to
                Riyadh, from Salalah to Dubai, our gloves protect millions of hands every year.
              </p>
              <p className="font-arabic text-right leading-loose" dir="rtl">
                تأسست شركتنا في عُمان، وأصبحنا أحد أبرز موردي القفازات الطبية والصناعية
                بالجملة في منطقة الخليج. نخدم المستشفيات ومصانع المواد الغذائية والمختبرات
                والمنشآت الصناعية بجودة ثابتة وتوريد موثوق.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              
              <div className="flex items-center gap-2 text-sm font-semibold text-navy">
                <i className="ri-checkbox-circle-line text-brand-green text-lg" />
                Quality Assured
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-navy">
                <i className="ri-checkbox-circle-line text-brand-green text-lg" />
                Oman Based &amp; Operated
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-navy">
                <i className="ri-checkbox-circle-line text-brand-green text-lg" />
                Bulk &amp; Contract Supply
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
